export default [
  {
    path: '/intercom',
    component: () => import('@/components/Layer.vue'),
    children: [
      {
        path: '/intercom/',
        name: 'intercomManagement',
        component: () => import('@/views/Intercom/IntercomManagement.vue'),
        children: [
          {
            path: '',
            redirect: { name: 'callRecordList' }
          },
          {
            path: 'callRecordList',
            name: 'callRecordList',
            component: () => import('@/views/Intercom/CallRecordList.vue'),
            meta: {
              prev: 'goHome'
            }
          },
          {
            path: 'sentryManagement',
            name: 'sentryManagement',
            component: () => import('@/views/Intercom/SentryManagement.vue'),
            meta: {
              prev: 'goHome'
            }
          },
          {
            path: 'residentOpen',
            name: 'residentOpen',
            component: () => import('@/views/Intercom/ResidentOpen.vue'),
            meta: {
              prev: 'goHome'
            }
          }
        ]
      }
    ]
  }
]
